import { Col, Placeholder, Stack } from 'react-bootstrap';

export const MembersSkeleton = () => {
	return (
		<>
			<Col xxl={4} xl={6} md={4} sm={6}>
				<Stack className="business-box">
					<div className="business-box-logo"></div>
					<div className="">
						<Placeholder animation="glow">
							<Placeholder xs={12} size="lg" />
							<Placeholder xs={12} size="sm" />
						</Placeholder>
					</div>
					<Placeholder.Button variant="primary" className="filled-btn rounded-pill lh-1" />
				</Stack>
			</Col>
			<Col xxl={4} xl={6} md={4} sm={6}>
				<Stack className="business-box">
					<div className="business-box-logo"></div>
					<div className="">
						<Placeholder animation="glow">
							<Placeholder xs={12} size="lg" />
							<Placeholder xs={12} size="sm" />
						</Placeholder>
					</div>
					<Placeholder.Button variant="primary" className="filled-btn rounded-pill lh-1" />
				</Stack>
			</Col>
			<Col xxl={4} xl={6} md={4} sm={6}>
				<Stack className="business-box">
					<div className="business-box-logo"></div>
					<div className="">
						<Placeholder animation="glow">
							<Placeholder xs={12} size="lg" />
							<Placeholder xs={12} size="sm" />
						</Placeholder>
					</div>
					<Placeholder.Button variant="primary" className="filled-btn rounded-pill lh-1" />
				</Stack>
			</Col>
			<Col xxl={4} xl={6} md={4} sm={6}>
				<Stack className="business-box">
					<div className="business-box-logo"></div>
					<div className="">
						<Placeholder animation="glow">
							<Placeholder xs={12} size="lg" />
							<Placeholder xs={12} size="sm" />
						</Placeholder>
					</div>
					<Placeholder.Button variant="primary" className="filled-btn rounded-pill lh-1" />
				</Stack>
			</Col>
			<Col xxl={4} xl={6} md={4} sm={6}>
				<Stack className="business-box">
					<div className="business-box-logo"></div>
					<div className="">
						<Placeholder animation="glow">
							<Placeholder xs={12} size="lg" />
							<Placeholder xs={12} size="sm" />
						</Placeholder>
					</div>
					<Placeholder.Button variant="primary" className="filled-btn rounded-pill lh-1" />
				</Stack>
			</Col>
			<Col xxl={4} xl={6} md={4} sm={6}>
				<Stack className="business-box">
					<div className="business-box-logo"></div>
					<div className="">
						<Placeholder animation="glow">
							<Placeholder xs={12} size="lg" />
							<Placeholder xs={12} size="sm" />
						</Placeholder>
					</div>
					<Placeholder.Button variant="primary" className="filled-btn rounded-pill lh-1" />
				</Stack>
			</Col>
			<Col xxl={4} xl={6} md={4} sm={6}>
				<Stack className="business-box">
					<div className="business-box-logo"></div>
					<div className="">
						<Placeholder animation="glow">
							<Placeholder xs={12} size="lg" />
							<Placeholder xs={12} size="sm" />
						</Placeholder>
					</div>
					<Placeholder.Button variant="primary" className="filled-btn rounded-pill lh-1" />
				</Stack>
			</Col>
			<Col xxl={4} xl={6} md={4} sm={6}>
				<Stack className="business-box">
					<div className="business-box-logo"></div>
					<div className="">
						<Placeholder animation="glow">
							<Placeholder xs={12} size="lg" />
							<Placeholder xs={12} size="sm" />
						</Placeholder>
					</div>
					<Placeholder.Button variant="primary" className="filled-btn rounded-pill lh-1" />
				</Stack>
			</Col>
		</>
	);
};

export default MembersSkeleton;
